<template>
  <div>
    <v-btn
      :disabled="disabled"
      @click="clickHandler"
      :class="styles"
      small
      icon
      flat
      color="primary"
    >
      <v-icon>{{ icon }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { showLabelOnHover } from '@/components/Shared/Button/iconButtonStyles'

const defaultOptions = {
  editLabel: '編集',
  saveLabel: '適用',
  editIcon: 'edit',
  saveIcon: 'save',
}

export default {
  name: 'AppEditButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    icon() {
      return this.editing
        ? this.mergedOptions.saveIcon
        : this.mergedOptions.editIcon
    },
    label() {
      return this.editing
        ? this.mergedOptions.saveLabel
        : this.mergedOptions.editLabel
    },
    styles() {
      return showLabelOnHover(this.label)
    },
    mergedOptions() {
      return {
        ...defaultOptions,
        ...this.options,
      }
    },
  },
  methods: {
    clickHandler() {
      if (this.editing) {
        this.$emit('onSaveClick')
      } else {
        this.$emit('onEditClick')
      }
    },
  },
}
</script>

<style scoped></style>
